import router from './router'
/* tslint:disable:no-var-requires */
const store = require('store')
import axios from 'axios'

export default {
  loader: false,
  user: {
    authenticated: false,
    profile: {
      id: '',
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      office_id: '',
      phone: '',
      state_id: '',
      city: '',
      zip: '',
      address: '',
      assigned_at: '',
      is_activ: '',
    },
    errors: {
      email: '',
      password: '',
    },
  },
  // VALIDATION REFACTOR
  login(context: any, email: string, password: string) {
    this.loader = true
    axios.post('login', {
      email,
      password,
    }).then((response) => {
      this.loader = false
      context.serverError = false
      store.set('jwt-token', response.data.token)
      /* tslint:disable:no-string-literal */
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token

      this.user.authenticated = true
      this.user.profile = response.data.user
      store.set('user', response.data.user)
      router.push('/')
    }).catch((error) => {
      this.loader = false
      context.serverError = error.response.data.message
      if (error.response.data.message === 'Invalid credentials') {
        this.user.errors.email = error.response.data.message
        this.user.errors.password = error.response.data.message
      } else {
        // this.user.errors.email = error.response.data.details.email[0]
        this.user.errors.email = 'The username field is required.'
        this.user.errors.password = error.response.data.details.password[0]
      }
    })
  },
  logout() {
    store.remove('jwt-token')
    store.remove('user')
    this.user.authenticated = false
    this.user.profile = {
      id: '',
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      office_id: '',
      phone: '',
      state_id: '',
      city: '',
      zip: '',
      address: '',
      assigned_at: '',
      is_activ: '',
    }

    router.push('/login')
  },
  init() {
    /* tslint:disable:no-string-literal */
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.get('jwt-token')
    this.user.profile = store.get('user')

    // Vue.prototype.$guard.permissions = !!this.user.profile ? this.user.profile.permissionsList : []
    // Vue.prototype.$guard.roles = !!this.user.profile ? this.user.profile.rolesList : []
  },
}
